import { type PaginatedMaintenance, type PaginatedTransformedMaintenance } from "@/api/resources/maintenances/types";
import {
  getExcludedMaintenancesByStrategy,
  getMaintenancesUpcomingVirtual,
  isVirtualMaintenance,
} from "@/api/resources/maintenances/utils";
import {
  defaultMaintenanceItemsStatusProgressDetails,
  getMaintenanceItemsStatusProgress,
  getMaintenanceItemsStatusProgressDetails,
} from "@/api/resources/maintenancesToDevices/utils";
import { type PaginatedMaintenanceStrategy } from "@/api/resources/maintenanceStrategies/types";
import { filterNotEmpty, sortObjectsBy } from "@/utils/format";

export const transformPaginatedMaintenances = (
  _maintenances: PaginatedMaintenance[],
): PaginatedTransformedMaintenance[] => {
  return _maintenances.filter(filterNotEmpty).map((maintenance) => {
    const maintenance_strategy = maintenance.maintenance_strategy;

    const devices = maintenance.maintenances_to_devices;

    const planned_devices = maintenance.maintenance_strategy
      ? maintenance.maintenance_strategy.maintenance_strategies_to_devices
      : [];

    const _planned_devices_count_strategy = planned_devices.length;
    const _planned_devices_count_maintenance = devices.length > 0 ? devices.length : 0;
    const planned_devices_count = isVirtualMaintenance(maintenance)
      ? _planned_devices_count_strategy
      : _planned_devices_count_maintenance;

    let status_progress = 0;
    let status_progress_max = 0;
    let status_progress_details = defaultMaintenanceItemsStatusProgressDetails;

    if (maintenance.maintenance_items.length > 0) {
      status_progress_details = getMaintenanceItemsStatusProgressDetails(maintenance.maintenance_items);
      status_progress = getMaintenanceItemsStatusProgress(status_progress_details);
      status_progress_max = maintenance.maintenance_items.length;
    }

    return {
      ...maintenance,
      status_progress,
      status_progress_details,
      status_progress_max,
      planned_devices_count,
      strategy_name: maintenance_strategy?.title,
    };
  });
};

interface SelectorMaintenancesUpcomingProps {
  maintenancesUpcomingMaterialized?: PaginatedMaintenance[];
  maintenanceStrategiesActive?: PaginatedMaintenanceStrategy[];
  from: string;
  until: string;
}
export const selectorMaintenancesUpcoming = ({
  maintenancesUpcomingMaterialized,
  maintenanceStrategiesActive,
  from,
  until,
}: SelectorMaintenancesUpcomingProps) => {
  if (!maintenancesUpcomingMaterialized || !maintenanceStrategiesActive) {
    return { data: [], count: 0 };
  }
  const maintenancesExcluded = getExcludedMaintenancesByStrategy(maintenancesUpcomingMaterialized);

  const maintenancesUpcomingVirtual = getMaintenancesUpcomingVirtual({
    strategies: maintenanceStrategiesActive,
    excluded: maintenancesExcluded,
    from,
    until,
  });

  const data = [...maintenancesUpcomingMaterialized, ...maintenancesUpcomingVirtual].sort(
    sortObjectsBy("planned_date", { order: "asc" }),
  );

  const count = maintenancesUpcomingMaterialized.length + maintenancesUpcomingVirtual.length;
  return { data, count };
};
